module.exports = __webpack_public_path__ + "static/media/Poppins-Thin.a61eaf4c.ttf";